import { getAuthToken, currentUserId } from 'utils/auth'
import * as qs from 'utils/querystring'

export function onboarding(latitude, longitude, userId, street, colony) {
  const baseUrl = process.env.WILLKOMMEN_ROOT;

  assertParameters({ latitude, longitude, userId, street, colony });

  const format = {
    encode: false,
    arrayFormat: 'brackets'
  };

  const querystring = qs.stringify({
    neighborhood: `${street}, ${colony}`,
    latitude: latitude,
    longitude: longitude,
    userId: userId,
  }, format)

  return `${baseUrl}s/aliadas${querystring}`
}

export function serviceSetup () {
  const path = `/booking/configurar`
  return prependWithUserProfile(path)
}

export function serviceSetupStep (step) {
  if (!step) {
    return serviceSetup()
  }

  const path = `/booking/configurar?step=${step}`
  return prependWithUserProfile(path)
}

export function aliadaSearch (querystring = '') {
  const path = `/booking/busqueda${querystring}`
  return prependWithUserProfile(path)
}

export function aliadaProfile (aliadaId, queryobject = {}) {
  assertParameters({ aliadaId })

  const path = `/booking/aliadas/${aliadaId}`

  let querystring = qs.stringify(queryobject)
  const EMPTY_QUERYSTRING = '?'
  querystring = querystring === EMPTY_QUERYSTRING ? '' : querystring

  return prependWithUserProfile(path + querystring)
}

export function replaceAliadaProfile (userId, aliadaId, bookingType, bookingId, estimatedHours) {
  assertParameters({ userId, aliadaId, bookingType, bookingId })
  return `/perfil/${userId}/booking/aliadas/${aliadaId}?replaceAliada=1&bookingTypeId=${bookingType}&forBookingId=${bookingId}&estimatedHours=${estimatedHours}`
}

export function aliadaReserve (aliadaId) {
  assertParameters({ aliadaId })
  const path = `/booking/aliadas/${aliadaId}/reservar`
  return prependWithUserProfile(path)
}

export function aliadaReserveAddress (aliadaId) {
  assertParameters({ aliadaId })
  const path = `/booking/aliadas/${aliadaId}/reservar/direccion`
  return prependWithUserProfile(path)
}

export function aliadaReserveSuccess (aliadaId, queryobject) {
  assertParameters({ aliadaId })
  const querystring = buildQuerystring(queryobject)
  const path = `/booking/aliadas/${aliadaId}/reservar/exito` + querystring
  return prependWithUserProfile(path)
}

export function aliadaReserveInstructions (aliadaId, queryobject) {
  assertParameters({ aliadaId })
  const querystring = buildQuerystring(queryobject)
  const path = `/booking/aliadas/${aliadaId}/reservar/instrucciones` + querystring
  return prependWithUserProfile(path)
}

export function userProfile (userId) {
  assertParameters({ userId })
  return `/perfil/${userId}`
}

export function currentUserProfile () {
  const userId = getCurrentUserId()
  return userProfile(userId)
}

export function userEditProfile (userId) {
  assertParameters({ userId })
  return `/perfil/${userId}/cuenta`
}

export function userNextServices (userId) {
  assertParameters({ userId })
  return `/perfil/${userId}/servicios/proximos`
}

export function userPreviousServices (userId) {
  assertParameters({ userId })
  return `/perfil/${userId}/historial`
}

export function userModifyService (userId, serviceId) {
  assertParameters({ userId, serviceId })
  return `/perfil/${userId}/servicios/${serviceId}/modificar`
}

export function userCancelService (userId, serviceId) {
  assertParameters({ userId, serviceId })
  return `/perfil/${userId}/servicios/${serviceId}/cancelar`
}

export function serviceChangeAliadaConfirm (userId, serviceId, queryobject) {
  assertParameters({ userId, serviceId })
  const querystring = buildQuerystring(queryobject)
  return `/perfil/${userId}/servicios/${serviceId}/cambiar-aliada/confirmar` + querystring
}

export function recurrenceChangeAliadaConfirm (userId, recurrenceId, queryobject) {
  assertParameters({ userId, recurrenceId })
  const querystring = buildQuerystring(queryobject)
  return `/perfil/${userId}/recurrencias/${recurrenceId}/cambiar-aliada/confirmar` + querystring
}

export function rescheduleService (userId, serviceId) {
  assertParameters({ userId, serviceId })
  return `/perfil/${userId}/servicios/${serviceId}/reagendar`
}

export function userModifyRecurrence (userId, recurrenceId) {
  assertParameters({ userId, recurrenceId })
  return `/perfil/${userId}/recurrencias/${recurrenceId}/modificar`
}

export function userCancelRecurrence (userId, recurrenceId) {
  assertParameters({ userId, recurrenceId })
  return `/perfil/${userId}/recurrencias/${recurrenceId}/cancelar`
}

export function rescheduleRecurrence (userId, recurrenceId) {
  assertParameters({ userId, recurrenceId })
  return `/perfil/${userId}/recurrencias/${recurrenceId}/reagendar`
}

export function recurrenceChangeAliadaSearch (userId, recurrenceId) {
  assertParameters({ userId, recurrenceId })
  return `/perfil/${userId}/recurrencias/${recurrenceId}/cambiar-aliada/buscar`
}

export function rescheduleServiceConfirm (userId, serviceId, queryobject) {
  assertParameters({ userId, serviceId })
  const querystring = buildQuerystring(queryobject)
  return `/perfil/${userId}/servicios/${serviceId}/reagendar/confirmar` + querystring
}

export function rescheduleRecurrenceConfirm (userId, recurrenceId, queryobject) {
  assertParameters({ userId, recurrenceId })
  const querystring = buildQuerystring(queryobject)
  return `/perfil/${userId}/recurrencias/${recurrenceId}/reagendar/confirmar` + querystring
}

export function serviceChangeAliadaSearch (userId, serviceId) {
  assertParameters({ userId, serviceId })
  return `/perfil/${userId}/servicios/${serviceId}/cambiar-aliada/buscar`
}

export function freeServices (userId) {
  assertParameters({ userId })
  return `/perfil/${userId}/servicios-gratis`
}

export function userInvoices (userId) {
  assertParameters({ userId })
  return `/perfil/${userId}/facturacion`
}

export function configureNewService () {
  return prependWithUserProfile('/booking/configurar')
}

export function logout () {
  return '/logout'
}

export function bookingConfirmation (aliadaId) {
  assertParameters({ aliadaId })
  const path = `/booking/aliadas/${aliadaId}/reservar`
  return prependWithUserProfile(path)
}

export function bookingPayment (aliadaId) {
  assertParameters({ aliadaId })
  const path = `/booking/aliadas/${aliadaId}/reservar/pagar`
  return prependWithUserProfile(path)
}

export function userCreateOrder (productSlug) {
  assertParameters({ productSlug })
  const path = `/comprar/producto/${productSlug}`
  return prependWithUserProfile(path)
}

function buildQuerystring (queryobject = {}) {
  const isEmpty = (obj) => Object.keys(obj).length === 0
  return isEmpty(queryobject) ? '' : qs.stringify(queryobject)
}

function prependWithUserProfile (path = '') {
  if (!loggedIn()) {
    return path
  }

  const userId = getCurrentUserId()

  const userProfilePath = userProfile(userId)
  return userProfilePath + path
}

function loggedIn () {
  return !!getAuthToken()
}

function getCurrentUserId () {
  return currentUserId.get()
}

function assertParameters (params = {}) {
  const missingParams = Object.keys(params).reduce((acc, param) => {
    const value = params[param]
    if (value === undefined) {
      acc.push(param)
    }

    return acc
  }, [])

  if (missingParams.length > 0) {
    const message = `Cannot create path. Missing parameters: ${missingParams.join(', ')}`
    throw new TypeError(message)
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/paths.js